module.exports = __webpack_public_path__ + "fonts/a9b456ecf721fd5f02beee709b4f6d83.txt";